export default "__VITE_ASSET__BuK_rbrf__"